<template>
	<div class="func-btn" :class="{ 'title-left': isTitleLeft }" @click="click">
		<div class="func-btn-inner">
			<span v-if="isTitleLeft">{{ title }}</span>
			<i class="icon" :class="icon"></i>
			<span v-if="!isTitleLeft">{{ title }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'funcBtn',
	components: {},
	props: {
		title: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		},
		isTitleLeft: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {}
	},
	computed: {},
	watch: {},
	methods: {
		click() {
			this.$emit('click')
		}
	},
	created() {},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
